import { render } from "./App.vue?vue&type=template&id=cfec567a"
const script = {}

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__